import { createPinia } from 'pinia'
import { onAuthContextChanged } from '@/@vxapp/Auth/authContext'

export const store = createPinia()
const businessStoreIds = new Set(['QuoteStore', 'InvoiceStore', 'OrderStore', 'MessagesStore'])

store.use(({ store: resource }) => {
  if (!businessStoreIds.has(resource.$id)) return
  const stop = onAuthContextChanged(() => resource.$reset())
  const dispose = resource.$dispose.bind(resource)

  resource.$dispose = () => {
    stop()
    dispose()
  }
})
export default function (app) {
  app.use(store)
}
